import React from 'react';
import { MapPin, Package, Settings, User } from 'lucide-react';
import './UserProfileSidebar.css';

const menuIconProps = { size: 18, strokeWidth: 1.75 };

const UserProfileSidebar = ({ activeSection, onSectionChange, user, profileCompletionLocked, showMyOrdersNav = true }) => {
    const menu = [
        { key: 'profile', Icon: User, label: 'Profile Information' },
        ...(showMyOrdersNav ? [{ key: 'orders', Icon: Package, label: 'My Orders' }] : []),
        { key: 'addresses', Icon: MapPin, label: 'Addresses' },
        { key: 'settings', Icon: Settings, label: 'Settings' },
    ];
    return (
        <aside className="sidebar">
            <div className="profile-avatar">
                <div className="avatar-container">
                    {user && user.name ? user.name.split(' ').map(n => n[0]).join('').toUpperCase() : 'U'}
                </div>
                <div className="user-name">{user && user.name ? user.name : 'User Name'}</div>
                <div className="user-email">{user && user.email ? user.email : 'user@email.com'}</div>
            </div>
            <ul className="menu-items">
                {menu.map(({ key, Icon, label }) => (
                    <li className="menu-item" key={key}>
                        <button
                            type="button"
                            disabled={profileCompletionLocked && key !== 'profile'}
                            className={`menu-link${activeSection === key ? ' active' : ''}${profileCompletionLocked && key !== 'profile' ? ' menu-link-disabled' : ''}`}
                            onClick={() => {
                                if (profileCompletionLocked && key !== 'profile') return;
                                onSectionChange(key);
                            }}
                        >
                            <span className="menu-icon" aria-hidden>
                                <Icon {...menuIconProps} />
                            </span>
                            {label}
                        </button>
                    </li>
                ))}
            </ul>
        </aside>
    );
};

export default UserProfileSidebar;
